const StatCard = ({ icon, label, value }) => {
  return (
    <div className="flex items-center justify-between p-4 rounded-2xl shadow-sm bg-white">
      <div className="flex items-center gap-4">
        <div className="text-[#1e9b6b]">{icon}</div>
        <div>
          <p className="text-sm text-gray-400 uppercase">{label}</p>
          <p className="text-2xl font-bold text-gray-900">{value}</p>
        </div>
      </div>
    </div>
  );
};

export default StatCard;
